import { RequestUnsuccessComponent } from '../self-request/request-unsuccess/request-unsuccess.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { LeavePageModalComponent } from '../self-request/leave-page-modal/leave-page-modal.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { BillingHeaderComponent } from '../billing-header/billing-header.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router , RouterModule } from '@angular/router';
import { switchMap, tap } from 'rxjs/operators';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import { FormControl, FormGroup, Validators , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { AcmicService,  ModalOptions } from '@mapfre-design-library/src/public_api';
import { BillingDiscountService } from '@services/data-services/billing-discount.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { BillingRequestService } from '@services/billing-request.service';
import { DiscountsService } from '@services/discounts.service';
import { UploadRequestDocumentsComponent } from '../self-request/upload-request-documents/upload-request-documents.component';
import { Constants } from '@models/constants';
import { BillingDetailsService } from '@services/my-insurance/billing-details.service';
import { Topic } from '@models/topic';
import { DocumentService } from '@services/document/document.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbFormsModule, MapfreLoadingComponent, MapfreCardComponent, BillingHeaderComponent, UploadRequestDocumentsComponent, MapfreButtonComponent, LeavePageModalComponent, MapfreModalComponent, RequestUnsuccessComponent],
  selector: 'app-billing-discount',
  templateUrl: './billing-discount.component.html',
  styleUrls: ['./billing-discount.component.scss']
})
export class BillingDiscountComponent implements OnInit {
  @ViewChild(UploadRequestDocumentsComponent)
  uploadedDocs!: UploadRequestDocumentsComponent
  
  loader: boolean;
  policy: any;
  policyType: string;
  documents: File[];
  loading: boolean;
  requestTypeList: Array<any>;
  policyTypeImg: string;
  billingDiscountForm: FormGroup;
  isAcmic: boolean;
  discountName = '';
  showGoodStudent: boolean;
  showPanMassChallenge: boolean;
  showStudentAway: boolean;
  discountOptions: Topic[];
  discountVal = '';
  showSubmitUnsuccessModal: boolean;
  submitLoading: boolean;
  failureSubmitModal: ModalOptions;
  hideModal = false;
  showLeaveModal: boolean;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private acmicService: AcmicService,
    private billingDiscountService: BillingDiscountService,
    private storageObservable: StorageServiceObservablesService,
    private billingRequestService: BillingRequestService,
    private discountsService: DiscountsService,
    private billingDetailsService: BillingDetailsService,
    private docService: DocumentService
  ) {
    this.showGoodStudent = false;
    this.showPanMassChallenge = false;
    this.showStudentAway = false;
    this.showSubmitUnsuccessModal = false;
    this.showLeaveModal = false;
    this.submitLoading = false;

  }

  ngOnInit(): void {
    this.loading = true;
    this.documents = [];
    this.discountOptions = this.discountsService.getDiscountOptions();
    this.activatedRoute.params.subscribe((params: Params) => {
      const policyId = params['policyid'];
      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        if (policyResponse) {
          this.policy = policyResponse
            .find(policyDetails => policyDetails.policynumber.policyNumber === policyId);
          this.setPolicyInfo(this.policy)
          this.loading = false;
        }
      });
    });
    this.isAcmic = this.acmicService.isACMIC();
    this.clearForm()
    this.initFailureSubmitModal();
  }

  setPolicyInfo(policy: any) {
    this.policyType = this.policy?.policyType;
    this.policyTypeImg = this.billingRequestService.setPolicyTypeImage(this.policyType);
    this.requestTypeList = this.billingRequestService.getRequestTypeList(policy);
  }

  clearForm() {
    this.billingDiscountForm = new FormGroup({
      discount: new FormControl(null, Validators.required),
      additionalInfoText: new FormControl('')
    });
  }

  initFailureSubmitModal(): void {
    this.failureSubmitModal = new ModalOptions({
      additionalClasses:
        'modal-lg modal-dialog center-on-page confirm-modal email-update edit-contact-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'failureSubmitModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      size: 'modal-lg',
      modalName: 'failure-Submit-Modal',
    });
    this.loading = false;
  }

  resetHideModal(){
    this.hideModal = !this.hideModal;
  }

  reload(event: boolean){
    this.showLeaveModal = false;
    if(event){
      this.ngOnInit()
    }
  }

  tryAgain(event: boolean){
    this.showSubmitUnsuccessModal = false;
    if(!event){
      this.router.navigate(['/my-insurance', this.policy?.policynumber?.policyNumber, 'billing']);
    }
  }

  onSubmit() {
    const subTopic = this.billingDiscountForm.controls.discount.value;
    const insured = this.policy.insured.find(insured => insured.isPrimaryInsured);

    const emailContent = {
      policyNumber: this.policy.policynumber.policyNumber,
      policyType: this.policy?.displayType?.label?.toUpperCase() ?? this.policy?.policyType,
      firstName: insured.firstName,
      lastName: insured.lastName,
      inquiryDate: new Date().toLocaleDateString(),
      inquiryTime: new Date().toLocaleTimeString(),
      inquiryTopic: Constants.DISCOUNT_TOPIC,
      inquiry: this.billingDiscountForm.controls.additionalInfoText.value,
      email: this.storageObservable.getUserFromStorage(),
      addProperties: { 
          inquirySubTopic: subTopic
        },
      isSelfCustomerRequest: true,
      hasAttachments: true
    };

    const requestPayload: FormData = new FormData();
    requestPayload.append('content', JSON.stringify(emailContent));

    const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.gif'];
    const allowedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'];

    this.documents.forEach((file) => {
      const isExtensionAllowed = allowedExtensions.some(ext => file.name.toLowerCase().endsWith(ext));
      const isMimeTypeAllowed = allowedMimeTypes.includes(file.type);
      if (!isExtensionAllowed || !isMimeTypeAllowed) return; // silently reject
      requestPayload.append('attachments', file, file.name);
    });
    
    if(subTopic==='Student Away discount'){
      this.billingDiscountService.setDiscountName('Student Away discount');
    }else if(subTopic==='Pan-Mass Challenge discount'){
      this.billingDiscountService.setDiscountName('Pan-Mass Challenge discount');
    }
    else{
      this.billingDiscountService.setDiscountName(subTopic);
    }
    this.submitRequest(requestPayload);
  }

  submitRequest(payload: any) {
    this.showSubmitUnsuccessModal = false;
    this.uploadedDocs.setLeavePage(true);
    this.submitLoading = true;

    this.docService.uploadSendGridAttachments(payload).pipe(
      tap(resp => {
        console.log("Discount Request :: Upload Docs done, status is ", resp)
      }),
      switchMap((uploadStatus: any) => {
        if(uploadStatus && 'COMPLETE' === uploadStatus)
          return this.billingDetailsService.sendBillingQuestion(payload.get("content"), this.storageObservable.getUserFromStorage())
      }))
      .subscribe(
        () => {
          this.router.navigate(['/my-insurance', this.policy.policynumber.policyNumber, 'discount-success'], {
            queryParams: { request: 'discount' }
          });
          this.submitLoading = false;
        },
        () => {
          this.showSubmitUnsuccessModal = true;
          this.submitLoading = false;
          return;
        }
      );
  }

  onDiscountChange() {
    if(this.discountVal && this.discountVal !==  this.billingDiscountForm.controls.discount.value){
      this.uploadedDocs.leavePage(event);
      this.documents = [];
      this.billingDiscountForm.controls.additionalInfoText.setValue(null);
    }
    this.discountVal = this.billingDiscountForm.controls.discount.value;
  }
  onClickBack() {
    if(!this.billingDiscountForm.controls.discount.value){
      this.router.navigate(['/my-insurance', this.policy.policynumber.policyNumber, 'billing-request'], {
        state: { openModal: true },
      });
    } else {
      if(this.documents.length){
        this.showLeaveModal = true;
      }else{
        this.ngOnInit()
      }
    }
  }

  saveUploadedFile(docs) {
    this.documents = docs;
  }

}
